/**
 *
 * @param {number} scaleUp
 * @returns {import('framer-motion').Variants}
 */
export const pulse = scaleUp => ({
  initial: { scale: 1 },
  animate: {
    scale: scaleUp,
    transition: { duration: 0.5, repeat: Infinity, repeatType: 'reverse' }
  }
})
